const ELECTROMAGNETIC = 0
const COMPANIONSHIP = 1
const COMPROMISE = 2
const DOMINANCE = 3
const PERSONAL = 4
const EDUCATIONAL = 5
const NATAL = 6

export default { ELECTROMAGNETIC, COMPANIONSHIP, COMPROMISE, DOMINANCE, PERSONAL, EDUCATIONAL, NATAL }
